/* import __COLOCATED_TEMPLATE__ from './read-attribute-operation.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { type AttributeInfoResolver } from '@intercom/embercom-prosemirror-composer';
import type { NodeSelection } from 'prosemirror-state';
import type Composer from '@intercom/embercom-prosemirror-composer/lib/composer';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { type OutputParam } from 'embercom/components/workflows/graph-editor/node-items/steps/fin-custom';
import type AttributeDescriptor from 'embercom/models/operator/visual-builder/attribute-descriptor';

interface Args {
  resolver: AttributeInfoResolver;
  onUpdateNode: (state: Record<string, unknown>, selection?: NodeSelection) => void;
  closePopover: () => void;
  composer: Composer;
  onCreateAttribute: (attribute: OutputParam) => Promise<AttributeDescriptor>;
}

export default class ReadAttributeOperation extends Component<Args> {
  @tracked selectedTemporaryAttribute?: OutputParam;
  @tracked showEditAttributeModal = false;
  @tracked selectedAttributeType?: string;

  @service declare appService: $TSFixMe;

  get app() {
    return this.appService.app;
  }

  get hasSubjectIdentifier(): boolean {
    return (
      (this.args.composer.state.prosemirrorState.selection as NodeSelection).node.attrs
        .subjectIdentifier !== undefined &&
      (this.args.composer.state.prosemirrorState.selection as NodeSelection).node.attrs
        .subjectIdentifier !== ''
    );
  }

  @action
  openModal(selectedTemporaryAttribute?: OutputParam): void {
    this.selectedTemporaryAttribute = undefined;
    if (this.app.canUseNewDataExperience) {
      if (this.hasSubjectIdentifier) {
        this.selectedTemporaryAttribute = selectedTemporaryAttribute;
        this.showEditAttributeModal = true;
        this.selectedAttributeType = 'temporary';
      }
    }
  }

  @action
  onUpdateAttributeIdentifier(identifier: string, selection?: NodeSelection): void {
    this.args.onUpdateNode(
      {
        subjectIdentifier: identifier,
        attributeValueType: 'fin',
      },
      selection,
    );

    this.args.closePopover();
  }

  @action
  async handleOnSubmit(attribute: OutputParam): Promise<void> {
    let attr: $TSFixMe;
    let selection: NodeSelection | undefined;

    selection = this.args.composer.state.prosemirrorState.selection as NodeSelection;

    attr = await this.args.onCreateAttribute(attribute);

    this.onUpdateAttributeIdentifier(attr.identifier, selection);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::FinCustom::AiPromptDataPopover::ReadAttributeOperation': typeof ReadAttributeOperation;
  }
}
